import React from "react";
import { Link } from "react-router-dom";
import "../service.css";

export const CustomerSatisfaction = () => {
  return (
    <div>
      <div className="tj-inner-banner">
        <div className="container">
          <h2>Customer Satisfaction</h2>
        </div>
      </div>

      <div className="tj-breadcrumb">
        <div className="container">
          <ul className="breadcrumb-list">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li className="active">Customer Satisfaction</li>
          </ul>
        </div>
      </div>
      <div className="container" style={{ paddingTop: "90px" }}>
        <div style={{ padding: "30px", display: "flex" }}></div>

        <h1 className="farex-h1" style={{ textAlign: "center" }}>
          Satisfied travelers, unforgettable trips
        </h1>

        {/*      <img
          src="https://cdn-cf.cms.farexbus.com/drupal-assets/styles/20px/s3/2024-07/Farex%20Tif_60_1170x420.jpg"
          className="basic-page-header-image basic-page-paragraph-container"
          alt="Customer satisfaction is one of our priorities"
          data-lazyload="https://cdn-cf.cms.farexbus.com/drupal-assets/styles/header_image_basic_page_0_5x/s3/2024-07/Farex%20Tif_60_1170x420.jpg 390w, https://cdn-cf.cms.farexbus.com/drupal-assets/styles/header_image_basic_page/s3/2024-07/Farex%20Tif_60_1170x420.jpg 780w, https://cdn-cf.cms.farexbus.com/drupal-assets/styles/header_image_basic_page_1_5x/s3/2024-07/Farex%20Tif_60_1170x420.jpg 1170w"
          sizes="100vw"
        /> */}

        <script
          type="application/javascript"
          src="https://privacy-proxy.usercentrics.eu/latest/uc-block.bundle.js"
        ></script>
        <script>uc.blockOnly(['BJz7qNsdj-7']);</script>

        <div id="section-53459" style={{ clear: "both" }}>
          <h2 className="farex-h2">
            <farex-icon
              size="6"
              solid="true"
              color="primary"
              name="thumbs-up"
              aria-hidden="true"
            ></farex-icon>
            <span className="farex-space-2-left">Travel smarter, not harder</span>
          </h2>
        </div>

        {/*         <div id="section-53460" style={{ clear: "both" }}>
          <section className="basic-page-paragraph-container left">
            <figure className="testimonial-wrapper">
              <img
                src="https://cdn-cf.cms.farexbus.com/drupal-assets/styles/20px/s3/2025-01/Nikhat%20Parveen.jpeg"
                alt="Nikhat Parveen"
                className="testimonial-image farex-avatar__image farex-avatar--xl"
                data-lazyload="https://cdn-cf.cms.farexbus.com/drupal-assets/styles/circle/s3/2025-01/Nikhat%20Parveen.jpeg 1x"
                sizes=""
              />

              <blockquote className="farex-blockquote testimonial-quote">
                <p>
                  The onboarding process at Farex Lounge is incredibly seamless,
                  with highly professional and helpful staff guiding you every
                  step of the way. From the offline booking to waiting for the
                  bus&apos;s arrival, they ensure a smooth experience. Upon
                  arrival, they escort passengers to the bus and assist with
                  boarding, creating a truly positive experience. The bus itself
                  is new, neat, and clean, making for an enjoyable journey
                  overall. I highly recommend Farex to everyone for their
                  excellent service and staff.
                </p>
                <figcaption>
                  <h3 className="farex-h3 farex-h3--space-flush">Nikhat Parveen</h3>
                  <div></div>
                </figcaption>
              </blockquote>
            </figure>
          </section>
        </div> */}

        <div id="section-53461" style={{ clear: "both" }}>
          <section className="basic-page-paragraph-container right">
            <figure className="testimonial-wrapper">
              {/*      <img
                src="https://cdn-cf.cms.farexbus.com/drupal-assets/styles/20px/s3/2025-01/Kuhu%20Saxena.jpeg"
                alt="Kuhu Saxena"
                className="testimonial-image farex-avatar__image farex-avatar--xl"
                data-lazyload="https://cdn-cf.cms.farexbus.com/drupal-assets/styles/circle/s3/2025-01/Kuhu%20Saxena.jpeg 1x"
                sizes=""
              /> */}

              <blockquote className="farex-blockquote testimonial-quote">
                <p className="p1">
                  I almost missed my bus today because of lack of availability
                  of cab and heavy traffic on road, but thanks to Farex staff,
                  they offered me an alternate boarding point closer to my area
                  and patiently waited for me to reach. I felt sorry for causing
                  the delay but situations were not in my hand too. However, i
                  would have lost both ticket and Ola cost if the bus had left
                  without me. So happy with their customer centric approach.
                  Thank you Farex!
                </p>
                <figcaption>
                  <h3 className="farex-h3 farex-h3--space-flush">Ajay Jaiswaal</h3>
                  <div></div>
                </figcaption>
              </blockquote>
            </figure>
          </section>
        </div>

        <div id="section-53462" style={{ clear: "both" }}>
          <h2 className="farex-h2">
            <farex-icon
              size="6"
              solid="true"
              color="primary"
              name="drinks"
              aria-hidden="true"
            ></farex-icon>
            <span className="farex-space-2-left">
              Relax in style, travel for less
            </span>
          </h2>
        </div>

        <div id="section-53463" style={{ clear: "both" }}>
          <section className="basic-page-paragraph-container left">
            <figure className="testimonial-wrapper">
              <blockquote className="farex-blockquote testimonial-quote">
                <p>
                  I recently had the opportunity to visit the Farex Lounge at
                  [sk ashram delhi] and was impressed with the overall
                  experience. Here are some highlights:
                </p>
                <ul>
                  <li>
                    <em>
                      <strong>Cleanliness</strong>: The lounge was spotless and
                      well-maintained, creating a comfortable atmosphere for
                      passengers.
                    </em>
                  </li>
                  <li>
                    <em>
                      <strong>Amenities</strong>: The lounge offered a range of
                      amenities, including free Wi-Fi, charging stations, and
                      complimentary snacks and beverages.
                    </em>
                  </li>
                  <li>
                    <em>
                      <strong>Comfort</strong>: The seating area was spacious
                      and comfortable, with ample legroom
                    </em>
                  </li>
                  <li>
                    <em>
                      <strong>Staff</strong>: The staff were friendly and
                      helpful, ensuring a smooth and hassle-free experience.
                    </em>
                  </li>
                  <li>
                    <em>
                      <strong>Value</strong>: The lounge provided excellent
                      value for the price, making it a great option for
                      travelers seeking a relaxing wait before their bus
                      departure.
                    </em>
                  </li>
                </ul>
                <p>Rating: 4.5/5 stars &nbsp;</p>
                <figcaption>
                  <h3 className="farex-h3 farex-h3--space-flush">Vijay</h3>
                  <div></div>
                </figcaption>
              </blockquote>
            </figure>
          </section>
        </div>

        <div id="section-53464" style={{ clear: "both" }}>
          <section className="basic-page-paragraph-container right">
            <figure className="testimonial-wrapper">
              <blockquote className="farex-blockquote testimonial-quote">
                <p>
                  The lounge is neat and clean and surprisingly very hygienic
                  too including the restrooms. Stayed here for around 4 hours
                  the cafeteria inside is pretty good with reasonable prices.
                  Service of the bus is also good on time with screen all around
                  to get information about your bus.
                </p>
                <figcaption>
                  <h3 className="farex-h3 farex-h3--space-flush">Aman Saxena</h3>
                  <div></div>
                </figcaption>
              </blockquote>
            </figure>
          </section>
        </div>

        <div id="section-53465" style={{ clear: "both" }}>
          <div
            className="farex-text basic-page-paragraph-container"
            style={{ overflowY: "auto" }}
          >
            <h2>Ready to get out there?</h2>
          </div>
        </div>

        <div id="section-53467" style={{ clear: "both" }}>
          <div className="basic-page-paragraph-container">
            <h2 className="farex-h2 farex-h2--section-header">
              Good vibes, great journey
            </h2>

            <div id="pixlee_container"></div>
          </div>
        </div>

        <div id="section-53468" style={{ clear: "both" }}>
          <div className="basic-page-paragraph-container">
            <Link
              to={"/booknow"}
              type="button"
              className="farex-btn farex-btn--primary"
            >
              Book your next trip
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
